import React, {PropsWithChildren, useEffect, useRef} from "react";
import MuiTabs, {TabsProps} from "@material-ui/core/Tabs";
import {makeStyles, TabsActions} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  tabsIndicator: {
    backgroundColor: theme.palette.primary.main,
    width: "100%",
  },
}));

type Props<T> = Omit<TabsProps, "onChange"> & {
  onChange: (value: T) => void;
  updateIndicatorAfterRender?: boolean;
};

const Tabs = <T,>(props: PropsWithChildren<Props<T>>) => {
  const classes = useStyles();
  const {updateIndicatorAfterRender, ...rest} = props;
  const ref = useRef<TabsActions>(null);

  useEffect(() => {
    // this effect change width of indicator after firsts render
    // it's useful for cases when you have component with loading data in tab title
    // For exaple bande with task count
    if (updateIndicatorAfterRender) {
      setTimeout(() => ref.current?.updateIndicator(), 1000);
    }
  }, [updateIndicatorAfterRender]);

  return (
    <MuiTabs
      {...rest}
      action={ref}
      onChange={(e, value) => props.onChange(value as T)}
      classes={{indicator: classes.tabsIndicator}}
    />
  );
};

export default Tabs;
